import {
  Accordion,
  Box,
  Text,
  AccordionButton,
  Heading,
  AccordionPanel,
  AccordionIcon,
  AccordionItem,
  Link
} from "@chakra-ui/react";
import {
  List,
  ListItem,
  ListIcon,
  OrderedList,
  UnorderedList
} from "@chakra-ui/react";
import React from "react";
import AppLayout from "../components/AppLayout";

export default function MentorsInstructions() {
  return (
    <AppLayout
      pageTitle={"Mentorship Program | Hack+Policy Participant Portal"}
    >
      <Box p="3" bg="green.100" borderRadius="sm">
        <Text fontSize="md">
          Timing for Mentor Hours: 26 June, 8:30 AM - 10:00 PM (PDT). Follow the
          instructions below to get a mentor.
        </Text>
      </Box>
      <Box mt="10" fontSize="md">
        <UnorderedList mt="8" fontSize="lg">
          <ListItem>
            Join the Hack+Policy Foundation{" "}
            <Link
              bg="yellow"
              href="https://discord.gg/gMGCCeue"
              target="_blank"
            >
              Discord server or the Zoom meeting{" "}
            </Link>
          </ListItem>
          <br />
          <ListItem>
            Drop a message in the #mentor-request channel stating your
            requirements during the mentor hours.
          </ListItem>
          <br />
          <ListItem>Mentors will reach out to you.</ListItem>
        </UnorderedList>
      </Box>
    </AppLayout>
  );
}
